import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import React, { useRef } from "react";

export interface StoreCarouselProps {
  children: React.ReactNode[];
  styleProps?: BoxProps;
}

const Carousel = styled(motion.div)({
  display: "flex",
  gap: "15px",
  overflow: "auto",
  scrollSnapType: "x mandatory",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

const CarouselWrapper = styled(Box)({
  position: "relative",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
});

const StoreCarousel = ({
  children,
  styleProps,
  ...props
}: StoreCarouselProps) => {
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const itemRefs = useRef<HTMLDivElement[]>([]);

  return (
    <CarouselWrapper {...styleProps}>
      <Carousel key={children.length} ref={carouselRef} {...props}>
        {React.Children.map(children, (child, index) => (
          <Box
            sx={{
              scrollSnapAlign: "start",
              flexShrink: 0,
            }}
            ref={(ref) => {
              const current = itemRefs.current[index];
              if (current && !ref) {
                itemRefs.current = itemRefs.current.filter(
                  (_, i) => i !== index
                );
                return;
              }
              itemRefs.current[index] = ref as HTMLDivElement;
            }}
            key={index}
          >
            {child}
          </Box>
        ))}
      </Carousel>
    </CarouselWrapper>
  );
};

export default StoreCarousel;
